import id from './id'
import createInitialState from './initial-state'
import selectorDefinitions from './selectors'
import actionsDefinition from './actions'
import { FiatOrderSet } from '@exodus/models'

const fiatRampRedux = ({ defaultFiatAmount = 100 } = {}) => ({
  id,
  type: 'redux-module',
  initialState: createInitialState({ defaultFiatAmount }),
  eventReducers: {
    fiatAssets: (state, payload) => ({
      ...state,
      assets: { ...state.assets, data: payload ?? {}, loaded: Boolean(payload) },
    }),
    fiatConfig: (state, payload) => ({
      ...state,
      config: { ...state.config, data: payload ?? {}, loaded: Boolean(payload) },
    }),
    fiatCountries: (state, payload) => ({
      ...state,
      countries: { ...state.countries, data: payload ?? {}, loaded: Boolean(payload) },
    }),
    fiatOrders: (state, payload) => ({
      ...state,
      orders: {
        ...state.orders,
        data:
          payload instanceof FiatOrderSet
            ? payload
            : FiatOrderSet.fromArray(Array.isArray(payload) ? payload : []),
        loaded: true,
      },
    }),
    fiatUser: (state, payload) => ({ ...state, user: { ...state.user, ...payload } }),
    fiatHiddenFailedOrderNotifications: (state, payload = {}) => ({
      ...state,
      hiddenFailedFiatOrderNotifications: payload,
    }),
  },
  actionReducers: {
    SET_FIAT_AMOUNT: (state, payload) => ({
      ...state,
      fiatAmount: payload,
    }),
    SET_IS_EMPTY_FROM_AMOUNT: (state, payload) => ({
      ...state,
      isEmptyFromAmount: payload,
    }),
  },
  selectorDefinitions,
  actionsDefinition,
})

export default fiatRampRedux
